import type { Atom, Getter, WritableAtom } from 'jotai/vanilla';

export const REFRESH = Symbol('REFRESH');

export interface TeoAtom<TValue>
  extends WritableAtom<
    TValue,
    [TValue | typeof REFRESH | ((prev: TValue) => TValue | typeof REFRESH)],
    void
  > {
  debugLabel?: string;
}

export type ReadFunction<TValue> = (get: Getter) => TValue;
export type Read<TValue> = ReadFunction<TValue> | TValue;

export type SetStateActionWithRefresh<TValue> =
  | TValue
  | typeof REFRESH
  | ((prev: TValue) => TValue | typeof REFRESH);

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export function atomLog(intro: string, atom: Atom<any>, ...args: unknown[]) {
  if (atom.debugLabel) {
    console.info('---------->>', intro ?? '', atom.debugLabel, ...args);
  }
}

// --- NOT-SET Value, for atoms, that should run their getters ---
const NOT_SET = Symbol();

export type NotSet = { notset: typeof NOT_SET };
export function unset(): NotSet {
  return { notset: NOT_SET };
}

export function isUnset(value: unknown): value is NotSet {
  return (value as NotSet).notset === NOT_SET;
}
